import JsZip from 'jszip';
const Promise = require('bluebird');
const FileSaver = require('file-saver');

// See https://huynvk.dev/blog/download-files-and-zip-them-in-your-browsers-using-javascript
export class ZipService {
    public static downloadAndZip(urls: Array<string>) {
        return this.downloadByGroup(urls, 5).then(this.exportZip);
    }

    private static download(url: string) {
        return fetch(url).then(resp => resp.blob());
    };

    private static downloadByGroup(urls: Array<string>, files_per_group: number = 5) {
        return Promise.map(
            urls,
            async (url: string) => {
                const blob = await this.download(url);
                return { url, blob };
            },
            { concurrency: files_per_group }
        );
    }

    private static exportZip(blobs: any) {
        const zip = JsZip();
        blobs.forEach((blob:any) => {
            zip.file(blob.url.split('/').pop(), blob.blob);
        });
        zip.generateAsync({ type: 'blob' }).then((zipFile: any) => {
            const currentDate = new Date().getTime();
            const fileName = `combined-${currentDate}.zip`;
            return FileSaver.saveAs(zipFile, fileName);
        });
    }

}